export const dayHeaderHeight = 49;
export const minTimeSlotHeight = 48;
export const minDayColumnWidth = 184;
export const gutterWidth = 24;
export const shiftSpacing = 20;
export const minShiftWidth = 40;